import { render, staticRenderFns } from "./printMould.vue?vue&type=template&id=2697590a&"
import script from "./printMould.vue?vue&type=script&lang=js&"
export * from "./printMould.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports